import type { ObjectDefinition } from '../../types/Schema';
import type { StudioSocketActions } from '../../actions/studio/socket';
import { RESET_STUDIO_ACTION } from '../consts';

export interface State {
    trackedMessaged: string[];
    isGlobalDataReloaded: boolean;
    isTrackingMessages: boolean;
    objectsChanged: ObjectDefinition[];
}

const getDefaultState = (): State => ({
    trackedMessaged: [],
    objectsChanged: [],
    isGlobalDataReloaded: false,
    isTrackingMessages: false
});

const studioSocketReducer = (state = getDefaultState(), action: StudioSocketActions | null): State => {
    switch (action?.type) {
        case 'SET_TRACKING_SOCKET_MESSAGES': {
            const { isTracking } = action.data;
            return {
                ...state,
                isTrackingMessages: isTracking,
                isGlobalDataReloaded: isTracking ? false : state.isGlobalDataReloaded,
                trackedMessaged: isTracking ? [] : state.trackedMessaged,
                objectsChanged: isTracking ? [] : state.objectsChanged
            };
        }

        case 'TRACK_SOCKET_MESSAGE': {
            const { messages, isGlobalDataReloaded = false, objectsChanged } = action.data;
            return {
                ...state,
                trackedMessaged: state.trackedMessaged.concat(messages ?? []),
                isGlobalDataReloaded: state.isGlobalDataReloaded ? true : isGlobalDataReloaded,
                objectsChanged: state.objectsChanged.concat(objectsChanged ?? [])
            };
        }

        case RESET_STUDIO_ACTION: {
            return getDefaultState();
        }

        default: {
            return state;
        }
    }
};

export default studioSocketReducer;
